import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FeesCost from "./fees-cost";
import FeesMortgageSelector from "./fees-mortgage-selector";
import FeesCostsLoader from "./loaders/fees-costs-loader";
import RefreshableTimeAgo from "@Shared/components/general/refreshable-timeago";
import { mapState, mapMutations, mapGetters } from "vuex";
import { mapMultiRowFields } from "@joandvgv/vuex-map-fields";
import { ADD_FEE_COST, REMOVE_FEE_COST } from "../../../../store/lender-submit-mutations";
import DuplicatorMixin from "@Shared/utils/application-mixins/duplicator-mixin";
import { REQUESTED_MORTGAGES } from "../../../../store/application-getters";
import { capitalize } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "FeesCosts",
  components: {
    FeesCost,
    FeesCostsLoader,
    FeesMortgageSelector,
    RefreshableTimeAgo
  },
  mixins: [DuplicatorMixin],
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapGetters("ApplicationStore", [REQUESTED_MORTGAGES])), mapState("ApplicationStore", ["feesCosts", "currentFeesMortgageType", "feesSavingStatus"])), mapMultiRowFields("ApplicationStore", ["feesCosts.first", "feesCosts.second", "feesCosts.third"])), {}, {
    feesCostsByMortgageType() {
      return this[this.currentFeesMortgageType];
    },
    loading() {
      return !this[this.currentFeesMortgageType].length;
    },
    updatedFeesAt() {
      return this.feesCosts.updatedAt || "";
    },
    columnHeaders() {
      return [{
        label: this.$t("direct-to-lender.commissions.fees.feeName"),
        size: "col-3 hidden-heading"
      }, {
        label: this.$t("global.words.amount"),
        size: "col-3"
      }, {
        label: this.$t("direct-to-lender.fees.deductFromPrincipal"),
        shortLabel: this.$t("direct-to-lender.fees.deduct"),
        size: "col col-lg-1 p-sm-0"
      }, {
        label: this.$t("direct-to-lender.fees.includeInAPR"),
        shortLabel: this.$t("direct-to-lender.fees.apr"),
        size: "col col-lg-1"
      }, {
        label: capitalize(this.$tc("global.words.comment", 2)),
        size: "col"
      }];
    }
  }),
  methods: _objectSpread(_objectSpread({}, mapMutations("ApplicationStore", [ADD_FEE_COST, REMOVE_FEE_COST])), {}, {
    handleAddFee() {
      this.ADD_FEE_COST(this.currentFeesMortgageType);
      this.handleSave();
    },
    handleRemoveFee(index) {
      this.REMOVE_FEE_COST({
        mortgageType: this.currentFeesMortgageType,
        index
      });
      this.handleSave();
    },
    handleSave() {
      this.$emit("save");
    }
  })
});